import React from 'react';
import Config from 'root/globals/Config';
import { View } from 'react-native';
import { Input, FormControlLabel } from '@material-ui/core';
import CustomFormInput from './CustomFormInput';
import CustomCheckBox from './CustomCheckBox';
import _ from 'root/libs/exaforte/react/lodash';
import styles from 'root/globals/Defaults.less';

export default class CustomFileField extends CustomFormInput {
    constructor(props) {
        super(props);
        
        this.removeFile = this.removeFile.bind(this);
    }

    removeFile(checked) {
        if(checked == 't')
            this.props.model.set_field_data({field: this.props.field, value: ''});
        else
            this.props.model.set_field_data({field: this.props.field, value: this.props.model.start_data[this.props.field]});
    }

    getSupportedProps() {
        return {...super.getSupportedProps(), ..._.filterSupportedProps(this.props, {inputProps: true, inputRef: true})};
    }
    
    _onChange(event) {
        if(this.props.inputProps && this.props.inputProps.multiple)
            this.props.onChangeText(event.target.files);
        else
            this.props.onChangeText(event.target.files[0]);
    }
    
    getElement() {
        let props   = this.getSupportedProps();
        props.files = [props.value] || [];
        
        delete props.value;
        
        return <>
            <Input type={'file'} autoComplete="off" disableUnderline={true} onChange={this._onChange} {...props} />
            {this.props.model && !_.is_empty(this.props.model.start_data) && !_.is_empty(this.props.model.start_data[this.props.field]) && <>
                {/*<a href={Config.IMAGES_URL + 'file-' + this.props.model.config.name + '-' + this.props.model.get_field_data('id') + '-' + this.props.field + '.' + _.get_file_extension(this.props.model.start_data[this.props.field])} target={'_blank'}>{this.props.model.start_data[this.props.field]}</a>*/}
                {!this.props.mandatory && (_.is_empty(this.props.model.get_field_data(this.props.field)) || this.props.model.get_field_data(this.props.field) == this.props.model.start_data[this.props.field]) && <FormControlLabel control={<View><CustomCheckBox value={this.props.model.get_field_data(this.props.field) == '' ? 't' : 'f'} onChangeText={this.removeFile} /></View>} label={'Verwijder huidig bestand'} />}
            </>}
        </>;
    }
}